import React, { useState, useEffect, useContext } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { ManagerAuthContext } from "../context/AuthManager";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const AccountReport = () => {
  const { currentUserRF } = useContext(ManagerAuthContext);
  const today = moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD");

  const [userList, setUserList] = useState([]);
  const [userListX, setUserListX] = useState([]);
  const [mainList, setMainList] = useState([]);
  const [servAll, setAllServ] = useState([]);
  const [servl, setServl] = useState([]);
  const [lormAll, setLormAll] = useState([]);

  const [search, setSearch] = useState(today);
  const [serviceDate, setServiceDate] = useState(today);
  const [lormDate, setLormDate] = useState(today);

  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showLormModal, setShowLormModal] = useState(false);

  const [selectedMeli, setSelectedMeli] = useState(null);
  const [selectedServiceName, setSelectedServiceName] = useState(null);

  // === Get default data ===
  useEffect(() => {
    const fetchUsers = async () => {
      const res = await fetch(
        `https://clinic.salamatpayanew.ir/Register/filterDate/${currentUserRF.nezam}&${today}`
      );
      setUserList(await res.json());
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchRial = async () => {
      const res = await fetch(
        `https://clinic.salamatpayanew.ir/Register/filterDateRial/${currentUserRF.nezam}&${today}`
      );
      setUserListX(await res.json());
    };
    fetchRial();
  }, []);

  useEffect(() => {
    const fetchAllServices = async () => {
      const res = await fetch(
        `https://clinic.salamatpayanew.ir/Register/servAlls/${currentUserRF.nezam}`
      );
      setAllServ(await res.json());
    };
    fetchAllServices();
  }, []);

  // === Search by date ===
  const SearchList = async () => {
    const res = await fetch(
      `https://clinic.salamatpayanew.ir/Register/sicknesSperiodListXX/${currentUserRF.nezam}&${search}`
    );
    setMainList(await res.json());
  };

  // === Show services modal ===
  const serviceList = async (meli, date) => {
    const finalDate = date || today;
    setSelectedMeli(meli);
    setServiceDate(finalDate);
    const res = await fetch(
      `https://clinic.salamatpayanew.ir/Register/filterServiceR/${meli}&${finalDate}`
    );
    setServl(await res.json());
    setShowServiceModal(true);
  };

  const updateServiceModalData = async () => {
    const res = await fetch(
      `https://clinic.salamatpayanew.ir/Register/filterServiceR/${selectedMeli}&${serviceDate}`
    );
    setServl(await res.json());
  };

  // === Show Lorm modal ===
  const handelShow = async (sname, date) => {
    const finalDate = date || today;
    setSelectedServiceName(sname);
    setLormDate(finalDate);
    const res = await fetch(
      `https://clinic.salamatpayanew.ir/Register/servAllLorm/${sname}&${currentUserRF.nezam}&${finalDate}`
    );
    setLormAll(await res.json());
    setShowLormModal(true);
  };

  const updateLormModalData = async () => {
    const res = await fetch(
      `https://clinic.salamatpayanew.ir/Register/servAllLorm/${selectedServiceName}&${currentUserRF.nezam}&${lormDate}`
    );
    setLormAll(await res.json());
  };

  if (currentUserRF.meli === null) {
    toast.warning("Error Session Erp");
    return null;
  }

  // === Calculate sums ===
  const totalRial = userListX.reduce((sum, v) => sum + v.price * 1, 0);
  const totalServiceModal = servl.reduce((sum, v) => sum + v.price * 1, 0);
  const totalLormCount = lormAll.length;
  const totalLormSum = lormAll.reduce((sum, v) => sum + v.price * 1, 0);

  // === Export Excel Function ===
  const exportToExcel = (data, filename) => {
    const sheetData = data.map(item => ({
      "نام": item.name || item.nameserv || "-",
      "کد ملی": item.meli || "-",
      "سرویس": item.servName || item.name || "-",
      "مبلغ": item.price || "-",
      "تاریخ": moment(item.date, "YYYY-MM-DD").locale("fa").format("YYYY/MM/DD"),
    }));

    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${filename}.xlsx`);
  };

  return (
    <>
      <section className="m-0 content" dir="rtl">
        <div className="row">
          <div className="d-flex flex-column flex-md-row justify-content-between">
            <div className="custom-form-control form-group position-relative w-50">
              <DatePicker
                calendar={persian}
                locale={persian_fa}
                value={search}
                onChange={(date) => setSearch(date?.format("YYYY-MM-DD"))}
                inputClass="form-control"
                placeholder="تاریخ را انتخاب کنید"
                format="YYYY-MM-DD"
              />
            </div>
            <div className="custom-form-control form-group position-relative w-50 ms-3">
              <button className="btn btn-success mt-4" onClick={SearchList}>
                جستجو بر اساس تاریخ
              </button>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table bg-white custom-rounded t-24 table-responsive">
            <thead>
              <tr className="text-center">
                <td>ردیف</td>
                <th>نام بیمار</th>
                <th>کد ملی</th>
                <th>مشاهده سرویس</th>
              </tr>
            </thead>
            {mainList.map((item, index) => (
              <tbody key={item.id}>
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.meli}</td>
                  <td>
                    <img
                      src="/img/cl.png"
                      height="25px"
                      width="25px"
                      style={{ cursor: 'pointer' }}
                      onClick={() => serviceList(item.meli, item.date)}
                    />
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
          <button
            className="btn btn-outline-primary"
            onClick={() => exportToExcel(mainList, "لیست-جستجو")}
          >
            خروجی اکسل
          </button>
        </div>
      </section>

      <hr />

      <section className="m-0 content" dir="rtl">
        <h5>حسابداری</h5>
        <div className="row">
          <div className="table-responsive">
            <table className="table bg-white custom-rounded t-24 table-responsive">
              <thead>
                <tr className="text-center">
                  <td>ردیف</td>
                  <th>نام بیمار</th>
                  <th>کد ملی</th>
                  <th>مشاهده سرویس</th>
                </tr>
              </thead>
              {userList.map((item, index) => (
                <tbody key={item.id}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.meli}</td>
                    <td>
                      <img
                        src="/img/cl.png"
                        height="25px"
                        width="25px"
                        style={{ cursor: 'pointer' }}
                        onClick={() => serviceList(item.meli, item.date)}
                      />
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
            جمع کل سرویس : {totalRial}
            <button
              className="btn btn-outline-success mt-2"
              onClick={() => exportToExcel(userList, "حسابداری")}
            >
              خروجی اکسل حسابداری
            </button>
          </div>
        </div>
      </section>

      {/* Modal Service */}
      <Modal show={showServiceModal} onHide={() => setShowServiceModal(false)}>
        <Modal.Body>
          <div className="mb-3">
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={serviceDate}
              onChange={(date) => setServiceDate(date?.format("YYYY-MM-DD"))}
              inputClass="form-control"
              placeholder="تاریخ سرویس"
              format="YYYY-MM-DD"
            />
            <button className="btn btn-primary mt-2" onClick={updateServiceModalData}>
              بروزرسانی
            </button>
            <button
              className="btn btn-outline-success mt-2 ms-2"
              onClick={() => exportToExcel(servl, "سرویس‌ها")}
            >
              خروجی اکسل
            </button>
          </div>
          <div className="table-responsive" dir="rtl">
            <table className="table bg-white custom-rounded t-24 table-responsive">
              <thead>
                <tr className="text-center">
                  <th>نام سرویس</th>
                  <th>مبلغ</th>
                </tr>
              </thead>
              {servl.map((item) => (
                <tbody key={item.id}>
                  <tr>
                    <td>{item.name}</td>
                    <td>{item.price}</td>
                  </tr>
                </tbody>
              ))}
            </table>
            جمع کل سرویس : {totalServiceModal}
          </div>
        </Modal.Body>
      </Modal>

      <hr />

      {/* Services */}
      <section className="m-0 content" dir="rtl">
        <h5>سرویس</h5>
        <div className="row">
          <div className="table-responsive">
            <table className="table bg-white custom-rounded t-24 table-responsive">
              <thead>
                <tr className="text-center">
                  <th>سرویس</th>
                  <th>تعداد</th>
                </tr>
              </thead>
              {servAll.map((item) => (
                <tbody key={item.id}>
                  <tr>
                    <td>{item.name}</td>
                    <td>
                      <img
                        src="/img/opt.png"
                        width="25px"
                        height="25px"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handelShow(item.name, item.date)}
                      />
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </div>
      </section>

      {/* Modal Lorm */}
      <Modal show={showLormModal} onHide={() => setShowLormModal(false)}>
        <Modal.Body>
          <div className="mb-3">
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={lormDate}
              onChange={(date) => setLormDate(date?.format("YYYY-MM-DD"))}
              inputClass="form-control"
              placeholder="تاریخ سرویس"
              format="YYYY-MM-DD"
            />
            <button className="btn btn-primary mt-2" onClick={updateLormModalData}>
              بروزرسانی
            </button>
            <button
              className="btn btn-outline-success mt-2 ms-2"
              onClick={() => exportToExcel(lormAll, "گزارش-سرویس")}
            >
              خروجی اکسل
            </button>
          </div>
          <div className="table-responsive" dir="rtl">
            <table className="table bg-white custom-rounded t-24 table-responsive">
              <thead>
                <tr className="text-center">
                  <th>بیمار</th>
                  <th>سرویس</th>
                  <th>مبلغ</th>
                </tr>
              </thead>
              {lormAll.map((item) => (
                <tbody key={item.id}>
                  <tr>
                    <td>{item.nameserv}</td>
                    <td>{item.name}</td>
                    <td>{item.price}</td>
                  </tr>
                </tbody>
              ))}
            </table>
            <span style={{ color: 'red' }}>جمع خدمات : {totalLormCount}</span>
            <br />
            <span style={{ color: 'blue' }}>جمع کل سرویس : {totalLormSum} تومان</span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
